import { TableCell, TableSortLabel } from '@mui/material';
import type { SortDirection } from '../utils/tableSort';

interface SortableHeaderProps<K extends string> {
  column: K;
  label: string;
  sort: K;
  order: SortDirection;
  onSort: (column: K) => void;
  align?: 'left' | 'right';
}

export default function SortableHeader<K extends string>({
  column,
  label,
  sort,
  order,
  onSort,
  align = 'left',
}: SortableHeaderProps<K>) {
  const active = sort === column;
  return (
    <TableCell align={align} sortDirection={active ? order : false}>
      <TableSortLabel active={active} direction={active ? order : 'asc'} onClick={() => onSort(column)}>
        {label}
      </TableSortLabel>
    </TableCell>
  );
}
